import React from "react";

const AboutAreaFour = () => {
  return (
    <>
      {/* =============== About Area Three End ===============*/}
      <div className='about-area pd-top-90'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6'>
              <div
                className='about-thumb-inner p-xl-5 pt-4 '
                data-aos='fade-right'
                data-aos-delay='200'
                data-aos-duration='1500'
              >
                <img
                  className='main-img m-md-4 rounded'
                  src='assets/img/about/about_home.png'
                  alt='img'
                />
              </div>
            </div>
            <div
              className='col-lg-6 align-self-center '
              data-aos='fade-left'
              data-aos-delay='250'
              data-aos-duration='1500'
            >
              <div className='section-title mt-5 mt-lg-0'>
                <h6 className='sub-title'>ABOUT US</h6>
                <h2 className='title'>
                Leading manufacturer and exporter of <span>Industrial Fittings, Including Elbows Tees</span> available in all types of material grades such as MS, SS, and aluminum etc.</h2>
                <p className='content mb-4 mb-xl-5'>
                We specialize in precision-forged industrial solutions, ensuring strength and durability. Committed to innovation, quality, and excellence in every product we deliver.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =============== About Area Three End ===============*/}
    </>
  );
};

export default AboutAreaFour;
